<template>
  <div>
   <div class="d-flex justify-start"> 
    <p class="text-h4"> {{ title }}</p>
    <div class="ml-3">
      <v-btn
      outlined
      color="blue"
      @click="showAllTable()"
    >
      Barchasi <v-avatar class="ml-2" color="blue" size="24">
        <p class="white--text text-caption mb-0">{{tableInfo.length}}</p>
      </v-avatar>
    </v-btn>
    </div>
    <div class="ml-3 mr-3">
    <v-btn
      outlined
      color="primary"
      @click="showUnreadTable()"
    >
      Yangi <v-avatar class="ml-2" color="primary" size="24">
        <p class="white--text text-caption mb-0">{{sortUnreadList.length}}</p>
      </v-avatar>
    </v-btn>
    </div>
    <div>
    <v-btn
      outlined
      color="indigo"
      @click="showReadTable()"
    >
      Javob berilgan 
      <v-avatar class="ml-2" color="indigo" size="24">
        <p class="white--text text-caption mb-0">{{sortReadList.length}}</p>
      </v-avatar>
    </v-btn>
    </div>
   </div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              N_
            </th>
            <th class="text-left">
              Ism, Familiya
            </th>
            <th class="text-left">
              Shaxs toifasi
            </th>
            <th class="text-left">
              Telefon raqam
            </th>
            <th class="text-left">
              Email
            </th>
            <th class="text-left">
              Matn
            </th>
            <th class="text-left">
              Sana
            </th>
            <th class="text-left d-md-block d-none" style="padding-top: 14px;">
            <v-icon color="grey" size="20">mdi-reply</v-icon> | <span v-if="userAuthData.username == 'admin'">Delete |</span> PDF 
            </th>
            <th class="text-left d-md-none d-block" style="padding-top: 5px;">
            <v-icon color="grey" size="20">mdi-reply</v-icon> | <span v-if="userAuthData.username == 'admin'">Delete</span> PDF
            </th>
          </tr>
        </thead>

        <tbody v-if="allAppeals">
          <tr v-for="item, index in tableInfo" :key="index" @dblclick="showInfo(index)">
            <td>{{ index + 1 }}.</td>
            <td>{{ item.last_name }} {{ item.name }}</td>
            <td>{{ item.catgory_of_person }}</td>
            <td>+998 {{ item.phone }}</td>
            <td>{{ item.email }}</td>
            <td v-if="item.text.length > 20">{{ item.text.slice(0, 20) }}...</td>
            <td v-else>{{ item.text }}</td>
            <td>{{ item.date.slice(0, 10) }}</td>
            <td class="d-flex justify-center align-center">
              <v-btn icon>
                <v-icon v-if="!item.status" color="grey" @click="checkAnswer(item.id)">mdi-check</v-icon>
                <v-icon v-else color="info" @click="showNotification(index)">mdi-check-all</v-icon>
                <v-snackbar v-model="snackbarSuccess" color="success" min-width="250" right top>
                  <span>Ushbu murojaatga javob berilgan.</span>
                  <template v-slot:action="{ attrs }">
                    <v-btn color="gray" text v-bind="attrs" @click="snackbarSuccess = false">
                      x
                    </v-btn>
                  </template>
                </v-snackbar>
              </v-btn>
              <v-btn icon v-if="userAuthData.username == 'admin'">
                <v-icon color="red" @click="showDelete(index)">mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon color="blue" @click="downloadFile(index)">mdi-download</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="unreadAppeals">
          <tr v-for="item, index in sortUnreadList" :key="index" @dblclick="showUnreadInfo(index)">
            <td>{{ index + 1 }}.</td>
            <td>{{ item.last_name }} {{ item.name }}</td>
            <td>{{ item.catgory_of_person }}</td>
            <td>+998 {{ item.phone }}</td>
            <td>{{ item.email }}</td>
            <td v-if="item.text.length > 20">{{ item.text.slice(0, 20) }}...</td>
            <td v-else>{{ item.text }}</td>
            <td>{{ item.date.slice(0, 10) }}</td>
            <td class="d-flex justify-center align-center">
              <v-btn icon>
                <v-icon v-if="!item.status" color="grey" @click="checkUnreadAnswer(item.id)">mdi-check</v-icon>
                <v-icon v-else color="info" @click="showNotification(index)">mdi-check-all</v-icon>
                <v-snackbar v-model="snackbarSuccess" color="success" min-width="250" right top>
                  <span>Ushbu murojaatga javob berilgan.</span>
                  <template v-slot:action="{ attrs }">
                    <v-btn color="gray" text v-bind="attrs" @click="snackbarSuccess = false">
                      x
                    </v-btn>
                  </template>
                </v-snackbar>
              </v-btn>
              <v-btn icon v-if="userAuthData.username == 'admin'">
                <v-icon color="red" @click="showUnreadDelete(index)">mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon color="blue" @click="downloadUnreadFile(index)">mdi-download</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="readAppeals">
          <tr v-for="item, index in sortReadList" :key="index" @dblclick="showReadInfo(index)">
            <td>{{ index + 1 }}.</td>
            <td>{{ item.last_name }} {{ item.name }}</td>
            <td>{{ item.catgory_of_person }}</td>
            <td>+998 {{ item.phone }}</td>
            <td>{{ item.email }}</td>
            <td v-if="item.text.length > 20">{{ item.text.slice(0, 20) }}...</td>
            <td v-else>{{ item.text }}</td>
            <td>{{ item.date.slice(0, 10) }}</td>
            <td class="d-flex justify-center align-center">
              <v-btn icon>
                <v-icon v-if="!item.status" color="grey" @click="checkAnswer(item.id)">mdi-check</v-icon>
                <v-icon v-else color="info" @click="showNotification(index)">mdi-check-all</v-icon>
                <v-snackbar v-model="snackbarSuccess" color="success" min-width="250" right top>
                  <span>Ushbu murojaatga javob berilgan.</span>
                  <template v-slot:action="{ attrs }">
                    <v-btn color="gray" text v-bind="attrs" @click="snackbarSuccess = false">
                      x
                    </v-btn>
                  </template>
                </v-snackbar>
              </v-btn>
              <v-btn icon v-if="userAuthData.username == 'admin'">
                <v-icon color="red" @click="showReadDelete(index)">mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon color="blue" @click="downloadReadFile(index)">mdi-download</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    
    <!-- all dialog -->
    <div class="text-center">
      <v-dialog v-model="dialog" width="700">
        <v-card>
          <v-card-title class="text-h5 darken-4 white--text" style="background-color: #0f172a;">
            Murojaat matni
          </v-card-title>

          <v-card-text class="mt-3 px-md-6 px-3">
            <p class="text-body-1 black--text" v-if="tableInfo">
              {{ tableInfo[numbers]?.text }}
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="#0f172a" @click="dialog = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- unread dialog -->
    <div class="text-center">
      <v-dialog v-model="dialogUnread" width="700">
        <v-card>
          <v-card-title class="text-h5 darken-4 white--text" style="background-color: #0f172a;">
            Murojaat matni
          </v-card-title>

          <v-card-text class="mt-3 px-md-6 px-3">
            <p class="text-body-1 black--text" v-if="sortUnreadList">
              {{ sortUnreadList[numbers]?.text }}
            </p>
            <p v-else> - - - </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="#0f172a" @click="dialogUnread = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
     <!-- read dialog -->
     <div class="text-center">
      <v-dialog v-model="dialogRead" width="700">
        <v-card>
          <v-card-title class="text-h5 darken-4 white--text" style="background-color: #0f172a;">
            Murojaat matni
          </v-card-title>

          <v-card-text class="mt-3 px-md-6 px-3">
            <p class="text-body-1 black--text" v-if="sortReadList">
              {{ sortReadList[numbers]?.text }}
            </p>
            <p v-else> - - - </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="#0f172a" @click="dialogRead = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!--all delete -->
    <div class="text-center">
      <v-dialog v-model="deleting" max-width="300">
        <v-card>
          <v-card-title class="text-h5">
           O'chirish
          </v-card-title>

          <v-card-text class="mt-3">
            <p class="text-body-1 black--text" v-if="tableInfo">
              Ushbu murojaatni o'chirishga aminmisiz?
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="deleting = false">
              Bekor qilish
            </v-btn>
            <v-btn text color="success" @click="deleteItem(tableInfo[numbers]?.id)">
              O'chirish
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
     <!--unread delete -->
     <div class="text-center">
      <v-dialog v-model="unreadDeleting" max-width="300">
        <v-card>
          <v-card-title class="text-h5">
            O'chirish
          </v-card-title>

          <v-card-text class="mt-3">
            <p class="text-body-1 black--text" v-if="sortUnreadList">
              Ushbu murojaatni o'chirishga aminmisiz?
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="unreadDeleting = false">
              Bekor qilish
            </v-btn>
            <v-btn text color="success" @click="deleteUnreadItem(sortUnreadList[numbers]?.id)">
              O'chirish
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
     <!--read delete -->
     <div class="text-center">
      <v-dialog v-model="readDeleting" max-width="300">
        <v-card>
          <v-card-title class="text-h5">
            O'chirish
          </v-card-title>

          <v-card-text class="mt-3">
            <p class="text-body-1 black--text" v-if="sortReadList">
              Ushbu murojaatni o'chirishga aminmisiz?
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="readDeleting = false">
              Bekor qilish
            </v-btn>
            <v-btn text color="success" @click="deleteReadItem(sortReadList[numbers]?.id)">
              O'chirish
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- edit status -->
    <div class="text-center">
      <v-dialog v-model="itemStatus" max-width="300">
        <v-card>
          <v-card-title class="text-h5">
            Status
          </v-card-title>

          <v-card-text class="mt-3">
            <p class="text-body-1 black--text" v-if="tableInfo">
             Ushbu murojaatga haqiqatdan ham javob berildimi? 
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="itemStatus = false">
              Bekor qilish
            </v-btn>
            <v-btn text color="success" @click="updateItem(tableInfo[0].id)">
              Tasdiqlash
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- edit unread status -->
    <div class="text-center">
      <v-dialog v-model="itemUnreadStatus" max-width="300">
        <v-card>
          <v-card-title class="text-h5">
            Status
          </v-card-title>

          <v-card-text class="mt-3">
            <p class="text-body-1 black--text" v-if="sortUnreadList">
              Ushbu murojaatga haqiqatdan ham javob berildimi? 
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="itemUnreadStatus = false">
              Bekor qilish
            </v-btn>
            <v-btn text color="success" @click="updateUnreadItem(sortUnreadList[0].id)">
              Tasdiqlash
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- all download -->
    <div class="pdf-wrap">
      <vue-html2pdf :enable-download="true" :float-layout="false" :show-layout="true" :preview-modal="false"
        :manual-pagination="true" :filename="`${tableInfo[numbers]?.name}-${tableInfo[numbers]?.last_name}`"
        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" :html2canvas="{ scale: 1, useCORS: true }"
        ref="html2Pdf">
        <section slot="pdf-content" class="d-none">
          <div class="pdf__item">
            <p class="head__title" v-if="tableInfo[numbers]?.send_who !== 'Boshqa'">
              {{ tableInfo[numbers]?.send_who }}ga murojaat</p>
            <p class="head__title" v-else>{{ tableInfo[numbers]?.send_who }}larga murojaat</p>
            <p class="section__head"><span class="section__style">Ism-familiya: </span> {{ tableInfo[numbers]?.name }} {{
              tableInfo[numbers]?.last_name }} </p>
            <p class="section__head"><span class="section__style">Email: </span>{{ tableInfo[numbers]?.email }}</p>
            <p class="section__head"><span class="section__style">Telefon raqam: </span>+998 {{ tableInfo[numbers]?.phone
            }}</p>
            <p class="section__head"><span class="section__style">Shaxs toifasi: </span>{{
              tableInfo[numbers]?.catgory_of_person }}</p>
            <p class="section__head"><span class="section__style">Murojaat sanasi: </span>{{
              tableInfo[numbers]?.date.slice(0, 10) }}</p>
            <div>
              <p class="body__title">Murojaat matni</p>
            </div>
            <div>
              <p class="text__style">{{ tableInfo[numbers]?.text.slice(0, 2350) }}</p>
            </div>

          </div>
          <div class="html2pdf__page-break" v-if="tableInfo[numbers]?.text.length > 2351"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ tableInfo[numbers]?.text.slice(2351, 6451) }}</p>
            </div>
          </div>
          <div class="html2pdf__page-break" v-if="tableInfo[numbers]?.text.length > 6452"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ tableInfo[numbers]?.text.slice(6453, 10553) }}</p>
            </div>
          </div>
        </section>
      </vue-html2pdf>

    </div>
    <!-- unread download-->
    <div class="pdf-wrap">
      <vue-html2pdf :enable-download="true" :float-layout="false" :show-layout="true" :preview-modal="false"
        :manual-pagination="true" :filename="`${sortUnreadList[numbers]?.name}-${sortUnreadList[numbers]?.last_name}`"
        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" :html2canvas="{ scale: 1, useCORS: true }"
        ref="html2PdfUnread">
        <section slot="pdf-content" class="d-none">
          <div class="pdf__item">
            <p class="head__title" v-if="sortUnreadList[numbers]?.send_who !== 'Boshqa'">
              {{ sortUnreadList[numbers]?.send_who }}ga murojaat</p>
            <p class="head__title" v-else>{{ sortUnreadList[numbers]?.send_who }}larga murojaat</p>
            <p class="section__head"><span class="section__style">Ism-familiya: </span> {{ sortUnreadList[numbers]?.name }} {{
              sortUnreadList[numbers]?.last_name }} </p>
            <p class="section__head"><span class="section__style">Email: </span>{{ sortUnreadList[numbers]?.email }}</p>
            <p class="section__head"><span class="section__style">Telefon raqam: </span>+998 {{ sortUnreadList[numbers]?.phone
            }}</p>
            <p class="section__head"><span class="section__style">Shaxs toifasi: </span>{{
              sortUnreadList[numbers]?.catgory_of_person }}</p>
            <p class="section__head"><span class="section__style">Murojaat sanasi: </span>{{
              sortUnreadList[numbers]?.date.slice(0, 10) }}</p>
            <div>
              <p class="body__title">Murojaat matni</p>
            </div>
            <div>
              <p class="text__style">{{ sortUnreadList[numbers]?.text.slice(0, 2350) }}</p>
            </div>

          </div>
          <div class="html2pdf__page-break" v-if="sortUnreadList[numbers]?.text.length > 2351"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ sortUnreadList[numbers]?.text.slice(2351, 6451) }}</p>
            </div>
          </div>
          <div class="html2pdf__page-break" v-if="sortUnreadList[numbers]?.text.length > 6452"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ sortUnreadList[numbers]?.text.slice(6453, 10553) }}</p>
            </div>
          </div>
        </section>
      </vue-html2pdf>

    </div>
     <!-- read download-->
     <div class="pdf-wrap">
      <vue-html2pdf :enable-download="true" :float-layout="false" :show-layout="true" :preview-modal="false"
        :manual-pagination="true" :filename="`${sortReadList[numbers]?.name}-${sortReadList[numbers]?.last_name}`"
        pdf-format="a4" pdf-orientation="portrait" pdf-content-width="800px" :html2canvas="{ scale: 1, useCORS: true }"
        ref="html2PdfRead">
        <section slot="pdf-content" class="d-none">
          <div class="pdf__item">
            <p class="head__title" v-if="sortReadList[numbers]?.send_who !== 'Boshqa'">
              {{ sortReadList[numbers]?.send_who }}ga murojaat</p>
            <p class="head__title" v-else>{{ sortReadList[numbers]?.send_who }}larga murojaat</p>
            <p class="section__head"><span class="section__style">Ism-familiya: </span> {{ sortReadList[numbers]?.name }} {{
              sortReadList[numbers]?.last_name }} </p>
            <p class="section__head"><span class="section__style">Email: </span>{{ sortReadList[numbers]?.email }}</p>
            <p class="section__head"><span class="section__style">Telefon raqam: </span>+998 {{ sortReadList[numbers]?.phone
            }}</p>
            <p class="section__head"><span class="section__style">Shaxs toifasi: </span>{{
              sortReadList[numbers]?.catgory_of_person }}</p>
            <p class="section__head"><span class="section__style">Murojaat sanasi: </span>{{
              sortReadList[numbers]?.date.slice(0, 10) }}</p>
            <div>
              <p class="body__title">Murojaat matni</p>
            </div>
            <div>
              <p class="text__style">{{ sortReadList[numbers]?.text.slice(0, 2350) }}</p>
            </div>

          </div>
          <div class="html2pdf__page-break" v-if="sortReadList[numbers]?.text.length > 2351"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ sortReadList[numbers]?.text.slice(2351, 6451) }}</p>
            </div>
          </div>
          <div class="html2pdf__page-break" v-if="sortReadList[numbers]?.text.length > 6452"></div>
          <div class="pdf__item">
            <div>
              <p class="text__style">{{ sortReadList[numbers]?.text.slice(6453, 10553) }}</p>
            </div>
          </div>
        </section>
      </vue-html2pdf>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  nama: "table",

  props: {
    title: {
      type: String,
      required: true,
    },
    tableInfo: {
      type: Array,
      required: true,
    }
  },

  components: { VueHtml2pdf },

  data: () => ({
    allAppeals:true,
    unreadAppeals:false,
    readAppeals:false,
    editStatus: {},
    snackbarSuccess: false,
    dialog: false,
    dialogUnread:false,
    dialogRead:false,
    deleting: false,
    unreadDeleting:false,
    readDeleting:false,
    itemStatus: false,
    itemUnreadStatus:false
  }),

  computed: {
    ...mapGetters("numbers", ["numbers"]),
    ...mapGetters("personal", ["person"]),
    userAuthData() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    sortUnreadList(){
      let newUnreaLists = this.tableInfo.filter((x)=>{return x.status == null})
      return newUnreaLists;
    },
    sortReadList(){
      let newReaLists = this.tableInfo.filter((x)=>{return x.status == true})
      return newReaLists;
    }
  },

  methods: {
    ...mapMutations("numbers", ["SET_NUMBER"]),
    ...mapActions("personal", ["getPerson", "deletePerson", "replyAppeal"]),
    checkAnswer(id) {
      axios.get(`https://api.uzgeouniver.uz/api/${id}`)
        .then(response => {
          this.itemStatus = !this.itemStatus
          this.editStatus = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    checkUnreadAnswer(id) {
      axios.get(`https://api.uzgeouniver.uz/api/${id}`)
        .then(response => {
          this.itemUnreadStatus = !this.itemUnreadStatus
          this.editStatus = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    showInfo(id) {
      this.SET_NUMBER(id);
      this.dialog = !this.dialog
    },
    showUnreadInfo(id){
      this.SET_NUMBER(id);
      this.dialogUnread = !this.dialogUnread
    },
    showReadInfo(id){
      this.SET_NUMBER(id);
      this.dialogRead = !this.dialogRead
    },
    showDelete(id) {
      this.SET_NUMBER(id);
      this.deleting = !this.deleting;
    },
    showUnreadDelete(id) {
      this.SET_NUMBER(id);
      this.unreadDeleting = !this.unreadDeleting;
    },
    showReadDelete(id) {
      this.SET_NUMBER(id);
      this.readDeleting = !this.readDeleting;
    },
    showNotification(id) {
      this.snackbarSuccess = true;
    },
    deleteItem(id) {
      this.SET_NUMBER(id);
      this.deletePerson(id);
      this.deleting = !this.deleting;
    },
    deleteUnreadItem(id){
      this.SET_NUMBER(id);
      this.deletePerson(id);
      this.unreadDeleting = !this.unreadDeleting;
    },
    deleteReadItem(id){
      this.SET_NUMBER(id);
      this.deletePerson(id);
      this.readDeleting = !this.readDeleting;
    },
    updateItem(id) {
      this.SET_NUMBER(id);
      this.newEditStatus = {
        status: true
      }
      this.replyAppeal({ id: this.editStatus.id, data: this.newEditStatus }).then(()=>{
        this.itemStatus = !this.itemStatus
      })
    },
    updateUnreadItem(id) {
      this.SET_NUMBER(id);
      this.newEditStatus = {
        status: true
      }
      this.replyAppeal({ id: this.editStatus.id, data: this.newEditStatus }).then(()=>{
        this.itemUnreadStatus = !this.itemUnreadStatus
      })
    },
    downloadFile(id) {
      this.SET_NUMBER(id);
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
      }, 100);
    },
    downloadUnreadFile(id) {
      this.SET_NUMBER(id);
      setTimeout(() => {
        this.$refs.html2PdfUnread.generatePdf();
      }, 100);
    },
    downloadReadFile(id) {
      this.SET_NUMBER(id);
      setTimeout(() => {
        this.$refs.html2PdfRead.generatePdf();
      }, 100);
    },
    showAllTable(){
      this.allAppeals = true;
      this.unreadAppeals = false;
      this.readAppeals = false;
    },
    showUnreadTable(){
      this.allAppeals = false;
      this.unreadAppeals = true;
      this.readAppeals = false;
    },
    showReadTable(){
      this.allAppeals = false;
      this.unreadAppeals = false;
      this.readAppeals = true;
    }
  },
  watch: {
    person: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.pdf-wrap {
  height: 80vh;
  padding: 0 30px;
}

.pdf__item {
  width: 100%;
  padding: 65px;
}

.head__title {
  color: #202746;
  font-size: 40px;
  margin-bottom: 20px;
  text-align: center;
}

.section__head {
  margin-bottom: 10px;
}

.section__style {
  color: #202746;
  font-weight: bolder;
}

.body__title {
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 30px;
  color: #202746;
  text-align: center;
}

.text__style {
  text-align: justify;
  line-height: 1.6;
}

::v-deep .v-input__slot {
  margin-bottom: 0;
}

::v-deep .v-messages {
  flex: 0;
  font-size: 0px;
  min-height: 0px;
  min-width: 0px;
  position: static;
}
</style>